import { Fragment, useEffect, useState } from "react";
import { Modal, Spinner, Button, Form } from "react-bootstrap";
import axios from "axios";
import { useUserState } from "../../../Contexts/UserContext";

import PlusSvg from "../../../assets/images/plus.svg";
import EditImg from "../../../assets/images/Edit.png";
import TrashImg from "../../../assets/images/Trash.png";
import FurnitureImage from "../../../assets/images/plammulti.png";

const PackageList = () => {
  const { user } = useUserState();

  const [packages, setPackages] = useState([]);
  const [isLoader, setIsLoader] = useState(false);

  // delete modal
  const [deleteModal, setDeleteModal] = useState(false);
  const [delPkgId, setDelPkgId] = useState("");
  const [delLoader, setDelLoader] = useState(false);

  // add/edit modal
  const [showPackageModal, setShowPackageModal] = useState(false);
  const [packageName, setPackageName] = useState("");
  const [editPackageId, setEditPackageId] = useState(null);
  const [modalLoader, setModalLoader] = useState(false);
  const [inputError, setInputError] = useState(false);

  // ---------------- API CALLS ----------------
  const getPackages = async () => {
    const headersFormData = {
      "Content-Type": "application/json",
      Authorization: user?.token,
    };
    if (user?.token) {
      setIsLoader(true);
      try {
        let res = await axios.get(
          `${
            import.meta.env.VITE_APP_BASE_URL
          }/api/furniture-category/get-category-list-by-company`,
          { headers: headersFormData }
        );
        setPackages(res?.data?.data || []);
        setIsLoader(false);
      } catch (err) {
        setIsLoader(false);
        console.log("get_packages", err);
      }
    }
  };

  const handleSavePackage = async () => {
    if (!packageName.trim()) {
      setInputError(true);
      return;
    }
    setInputError(false);

    const headersFormData = {
      "Content-Type": "application/json",
      Authorization: user?.token,
    };

    const payload = { name: packageName };

    try {
      setModalLoader(true);
      if (editPackageId) {
        // Update
        await axios.put(
          `${
            import.meta.env.VITE_APP_BASE_URL
          }/api/furniture-category/update/${editPackageId}`,
          payload,
          { headers: headersFormData }
        );
      } else {
        // Add
        await axios.post(
          `${import.meta.env.VITE_APP_BASE_URL}/api/furniture-category/create`,
          payload,
          { headers: headersFormData }
        );
      }
      setModalLoader(false);
      setShowPackageModal(false);
      setPackageName("");
      setEditPackageId(null);
      getPackages();
    } catch (err) {
      console.log("save_package", err);
      setModalLoader(false);
    }
  };

  const handleDeletePackage = async () => {
    const headersFormData = {
      "Content-Type": "application/json",
      Authorization: user?.token,
    };
    if (user?.token) {
      setDelLoader(true);
      try {
        await axios.delete(
          `${
            import.meta.env.VITE_APP_BASE_URL
          }/api/furniture-category/delete/${delPkgId}`,
          { headers: headersFormData }
        );
        setDelLoader(false);
        setDeleteModal(false);
        getPackages();
      } catch (err) {
        console.log("delete_package", err);
        setDelLoader(false);
      }
    }
  };

  // ---------------- LIFECYCLE ----------------
  useEffect(() => {
    getPackages();
  }, [user?.token]);

  // ---------------- HANDLERS ----------------
  const handleAddPackage = () => {
    setPackageName("");
    setEditPackageId(null);
    setShowPackageModal(true);
  };

  const handleEditPackage = (pkg) => {
    setPackageName(pkg?.name);
    setEditPackageId(pkg?.id);
    setShowPackageModal(true);
  };

  // ---------------- UI ----------------
  return (
    <Fragment>
      <div className="main-box">
        <div className="content-header">
          <h3>My Packages</h3>
          <button
            type="button"
            className="druyp-btn"
            onClick={handleAddPackage}
          >
            <img src={PlusSvg} alt="Edit" /> Add New Package Name
          </button>
        </div>

        <div className="myfurnit_store_main">
          <ul className="mystore_cont">
            {isLoader ? (
              <div className="eye-loader-frame m-5 p-5">
                <div className="eye-loader-spinner"></div>
              </div>
            ) : (
              <>
                {packages?.length > 0 ? (
                  packages?.map((pkg) => (
                    <li className="mystore_cont_inner" key={pkg?.id}>
                      <div className="my_store_img">
                        <img
                          src={FurnitureImage}
                          alt="package"
                          onError={(e) => {
                            e.target.src = FurnitureImage;
                          }}
                        />
                        <div
                          className="delux_edit_icon"
                          onClick={() => handleEditPackage(pkg)}
                        >
                          <img src={EditImg} alt="edit" />
                        </div>
                        {/* <div
                          className="trash_icon"
                          onClick={() => {
                            setDelPkgId(pkg?.id);
                            setDeleteModal(true);
                          }}
                        >
                          <img src={TrashImg} alt="trash" />
                        </div> */}
                      </div>
                      <h4>{pkg?.name}</h4>
                    </li>
                  ))
                ) : (
                  <p>There is currently no package</p>
                )}
              </>
            )}
          </ul>
        </div>
      </div>

      {/* Delete Modal */}
      <Modal
        show={deleteModal}
        onHide={() => setDeleteModal(false)}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Package</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this package!</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setDeleteModal(false)}>
            No
          </Button>
          <Button
            variant="primary"
            disabled={delLoader}
            onClick={handleDeletePackage}
          >
            Yes {delLoader && <Spinner />}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Add/Edit Package Modal */}
      <Modal
        show={showPackageModal}
        onHide={() => setShowPackageModal(false)}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {editPackageId ? "Edit Package Name" : "Add Package Name"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Package Name</Form.Label>
            <Form.Select
              value={packageName}
              onChange={(e) => setPackageName(e.target.value)}
            >
              <option value="">Select a package</option>
              <option value="Basic Plan">
                Basic Plan (entry-level, affordable)
              </option>
              <option value="Premium Plan">
                Premium Plan (more advanced benefits)
              </option>
              <option value="Deluxe Plan">
                Deluxe Plan (top tier, almost luxury)
              </option>
              <option value="Tier 1">Tier 1</option>
              <option value="Tier 2">Tier 2</option>
              <option value="Tier 3">Tier 3</option>
            </Form.Select>
            {inputError && !packageName && (
              <div className="text-danger mt-2">Package name is required</div>
            )}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowPackageModal(false)}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            disabled={modalLoader}
            onClick={handleSavePackage}
          >
            {editPackageId ? "Update" : "Save"}{" "}
            {modalLoader && <Spinner animation="border" size="sm" />}
          </Button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
};

export default PackageList;
